import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getStoredReferralCode } from "@/lib/affiliate-attribution";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Hook to track page views in Google Analytics for SPA route changes.
 * The initial page load is tracked by the gtag script in index.html.
 * This hook tracks subsequent client-side navigation.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Only track if gtag is available (script loaded)
    if (typeof window.gtag !== "function") return;

    const referralCode = getStoredReferralCode();

    window.gtag("config", import.meta.env.VITE_GA_MEASUREMENT_ID ?? "", {
      page_path: location.pathname + location.search,
      ...(referralCode && { referral_code: referralCode }),
    });
  }, [location.pathname, location.search]);
}
